/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function FirmwareStatusTableConfig($q, types, utils, userService, firmwareService) {

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig(isGroup) {      
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;

        var tableConfiguration = {

            scope: scope,
            tableTitle: 'firmware-table.status-table',

            columns: [
                {
                    key: 'firmwareLastCheckTime',
                    title: 'firmware-table.status-check-time',
                    time: true,
                    sort: true
                },
                {
                    key: 'gatewayGroupName',
                    title: 'firmware-table.gw-group-name',
                    hideIf: !isGroup
                },
                {
                    key: 'name',
                    title: 'gateway.name'
                },
                {
                    key: 'mac',
                    title: 'gateway.mac'
                },
                {
                    key: 'gatewayModelName',
                    title: 'gateway-model.gateway-model',
                    sort: true
                },
                {
                    key: 'firmwareVersion',
                    title: 'firmware-table.version'
                },
                {
                    key: 'firmwareState',
                    title: 'firmware-table.update-status',
                    sort: true
                },
                {
                    key: 'firmwareAvailableUpdates',
                    title: 'firmware-table.available-updates'
                },
                {
                    key: 'firmwareLastStateUpdateTs',
                    title: 'firmware-table.last-update-time',
                    time: true,
                    sort: true
                }
            ],

            loadEntities: (entities) => {
                var allEntities = [];
                var tasks = [];
                entities.forEach((entity) => {
                    let entityWithFirmware = entity;
                    tasks.push(firmwareService.getFirmwareReported(entity.id.id).then(
                        function success(response) {
                            entityWithFirmware.firmwareLastCheckTime = new Date();
                            entityWithFirmware.firmwareVersion = response.content.version;
                            entityWithFirmware.firmwareState = response.content.state;
                            entityWithFirmware.firmwareAvailableUpdates = response.content.availableUpdates;
                            entityWithFirmware.firmwareLastStateUpdateTs = response.lastStateUpdateTs;
                            allEntities.push(entityWithFirmware);
                        }, function fail() {
                            entityWithFirmware.firmwareState = "-";
                            entityWithFirmware.firmwareLastCheckTime = new Date();
                            allEntities.push(entityWithFirmware);
                        }
                    ));
                    
                }
                );
                return $q.all(tasks).then(function success() {
                    return allEntities;
                }, function fail() {
                });
            }
        };

        utils.tableConfigDefaults(tableConfiguration);
        return tableConfiguration;
    }
}


// WEBPACK FOOTER //
// ./src/app/firmware/firmware-status-table.config.js